function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import BackToMainView from 'components/BackToMainView';
import App, { AlertsBus } from 'modules/App';
import messages from '../../messages';
import DeleteAccountForm from '../../partials/DeleteAccountForm';
const DeleteAccount = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: "pageHeader",
                children: [
                    /*#__PURE__*/ _jsx(BackToMainView, {
                        routeName: "personal-information",
                        message: App.messages.headers.backToInformation
                    }),
                    /*#__PURE__*/ _jsx("h1", {
                        className: "text--h1",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.deleteAccount))
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("section", {
                className: "section",
                children: [
                    /*#__PURE__*/ _jsx(AlertsBus, {
                        className: "mb-5"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text--paragraph mb-7",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.deleteAccount))
                    }),
                    /*#__PURE__*/ _jsx(DeleteAccountForm, {
                        backRouteName: "personal-information"
                    })
                ]
            })
        ]
    });
export default DeleteAccount;
